"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PrintIcon = function PrintIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "size", "filled", "className", "children"]);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M0 13a1 1 0 0 0 1 1h3v2h8v-2h3a1 1 0 0 0 1-1V9H0zm10 1H6v-1h4zm-7-4h10v2h-1v-1H4v1H3zm11.573-5.256A1.243 1.243 0 0 0 13.435 4H8V0H4v4H2.541a1.243 1.243 0 0 0-1.141.75L0 8h16zM3 7l.5-1h9l.5 1zm9-4H9V0h.5L12 2.586z"
    }) : _react["default"].createElement("path", {
      d: "M10 14H6v-1h4zm6-6v5a1 1 0 0 1-1 1h-3v2H4v-2H1a1 1 0 0 1-1-1V8l1.4-3.25A1.243 1.243 0 0 1 2.54 4H4V0h5.5L12 2.586V4h1.435a1.243 1.243 0 0 1 1.138.744zM9 3h2L9 1zM5 6h6V4H8V1H5zM1.09 8h13.818l-1.252-2.856a.241.241 0 0 0-.22-.144H12v1h.5l.5 1H3l.5-1H4V5H2.541a.245.245 0 0 0-.224.146zM11 11H5v4h6zm4-2H1v4h3v-1H3v-2h10v2h-1v1h3z"
    }));
  }

  if (size <= 24) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M22.452 9.762A2.484 2.484 0 0 0 20.074 8H19V6h-6V0H5v8H3.926a2.484 2.484 0 0 0-2.378 1.762C.427 13.453.036 14.737 0 15h24c-.036-.263-.427-1.547-1.548-5.238zM4 12l.4-2.25H5V11h14V9.75h.6L20 12zm-4 7.75A2.25 2.25 0 0 0 2.25 22H5v2h14v-2h2.75A2.25 2.25 0 0 0 24 19.75V16H0zM16 22H8v-1h8zm0-2H8v-1h8zM4 17h16v2h-1v-1H5v1H4zM19 5h-5V.2l5 4.713z"
    }) : _react["default"].createElement("path", {
      d: "M22.452 9.762A2.484 2.484 0 0 0 20.074 8H19V4.913L13.789 0H5v8H3.926a2.484 2.484 0 0 0-2.378 1.762C.427 13.453.036 14.737 0 15v4.75A2.25 2.25 0 0 0 2.25 22H5v2h14v-2h2.75A2.25 2.25 0 0 0 24 19.75V15c-.036-.263-.427-1.547-1.548-5.238zM14 1.469L17.708 5H14zM6 1h7v5h5v5H6zm-3.538 9.194l.043-.141A1.477 1.477 0 0 1 3.927 9H5v.75h-.6L4 12h16l-.4-2.25H19V9h1.073a1.477 1.477 0 0 1 1.422 1.053l.043.141c.526 1.733.907 2.988 1.15 3.806H1.312c.243-.816.624-2.07 1.15-3.806zM18 23H6v-5h12zm5-3.25A1.251 1.251 0 0 1 21.75 21H19v-2h1v-2H4v2h1v2H2.25A1.251 1.251 0 0 1 1 19.75V15h22zM16 22H8v-1h8zm0-2H8v-1h8z"
    }));
  }

  return _react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), filled ? _react["default"].createElement("path", {
    d: "M31.922 19.773A50.18 50.18 0 0 0 30 14c-1-2-1.593-3-3.25-3H25V8h-8V0H7v11H5.25C3.593 11 3 12 2 14a50.194 50.194 0 0 0-1.922 5.773c-.018.076-.016.152-.026.227h31.896c-.01-.075-.008-.151-.026-.227zM6 16l.5-3H7v2h18v-2h.5l.5 3zm19-9h-7V0h.3L25 6.7zM0 21v5a3 3 0 0 0 3 3h4v3h18v-3h4a3 3 0 0 0 3-3v-5zm20.999 8H11v-1h9.999zm0-2H11v-1h9.999zM26 26h-1v-2H7v2H6v-3h20z"
  }) : _react["default"].createElement("path", {
    d: "M0 20v6a3 3 0 0 0 3 3h4v3h18v-3h4a3 3 0 0 0 3-3v-6zm24 11H8v-7h16zm7-5a2.003 2.003 0 0 1-2 2h-4v-2h1v-3H6v3h1v2H3a2.003 2.003 0 0 1-2-2v-5h30zm-10.001 3H11v-1h9.999zm0-2H11v-1h9.999zm10.923-7.227A50.18 50.18 0 0 0 30 14c-1-2-1.593-3-3.25-3H25V6.7L18.3 0H7v11H5.25C3.593 11 3 12 2 14a50.194 50.194 0 0 0-1.922 5.773c-.018.076-.016.152-.026.227h.984l.296-1a44.15 44.15 0 0 1 1.563-4.553C3.934 12.367 4.287 12 5.25 12H7v1h-.5L6 16h20l-.5-3H25v-1h1.75c.963 0 1.314.366 2.355 2.447A44.659 44.659 0 0 1 30.67 19l.297 1h.982c-.01-.075-.008-.151-.026-.227zM24 15H8V1h9v7h7zm0-8h-6V1.001h.01L24 6.991z"
  }));
};

var _default = PrintIcon;
exports["default"] = _default;